import ResetPwd from "../../section/auth/ResetPassword"
export default function ResetPassword(){

    return (
        <ResetPwd />
    )
}